export const accountingConstants = {
  SET_ACCOUNTING: 'SET_ACCOUNTING',
  SET_ACTIVE_CUSTOMERS: 'SET_ACTIVE_CUSTOMERS',
  ADD_ACTIVE_CUSTOMERS: 'ADD_ACTIVE_CUSTOMERS',
  UPDATE_ACTIVE_CUSTOMER: 'UPDATE_ACTIVE_CUSTOMER',
}
